import { RowWebMenuGroup, RowWebMenuGroupType } from "../../models/ModelWebMenuGroup";
import { MenuBranchSelector } from "../MenuBranchSelector";
import { MenuEditorTreeNode } from "../MenuEditorTreeNode";
import { MenuAction } from "./MenuAction";

export class MenuActionInclude extends MenuAction {
    private targetBranch: MenuEditorTreeNode;

    async internalExecute(): Promise<boolean> {
        const selector = new MenuBranchSelector({
            excludedNode: this.node,
            dialogProps: {
                title: "Select Submenu to include"
            }
        })

        this.targetBranch = await selector.show();
        if (this.targetBranch == null) {
            return false;
        }

        if (!this.targetBranch.menuItem.isSharedMenuReference()) {
            await this.targetBranch.menuItem.convertToShared();
        }
        await this.addSharedReference();
        return true;
    }

    override validate(): boolean {
        return this.node?.isMainMenuNode !== true && this.node?.hasChildren() === true;
    }

    async addSharedReference() {
        const newChild = this.targetBranch.menuItem.createCopy();
        const groupReference = new RowWebMenuGroup();
        await groupReference.populateDefaultValues();
        groupReference.setValues({
            group_type: RowWebMenuGroupType.SHARED_REFERENCE,
            include_group_id: newChild.groupData.get("id")
        });
        newChild.groupReferenceData = groupReference;
        newChild.groupReferenceData._appending = true;
        this.node.menuItem.addChild(newChild, true);
        this.menuItemToSelect = newChild;
    }
}
